import { gql } from "@stadium/services/apollo-client";

export const CREATE_CHILD_COMPANY = gql`
  mutation createChildCompany($input: String!) @api(name: "users") {
    createChildCompany(input: {}) {
      childCompany {
        id
        number
        packageIntentMappingKey(originalKey: $input)
        name
        ownerUser {
          email
        }
      }
      errors
      success
    }
  }
`;

export const VALIDATE_COMPANY_SUBSCRIPTION = gql`
  mutation validateCompanySubscription @api(name: "users") {
    validateCompanySubscription(input: {}) {
      errors
      success
    }
  }
`;
